import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    standalone: false,
    selector: 'por-pay-icon-text',
    templateUrl: './pay-icon-text.component.html',
    styleUrls: ['./pay-icon-text.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaymentIconWithTextComponent {
    // eslint-disable-next-line @angular-eslint/no-input-rename
    @Input({ required: true }) label!: string;

    @Input() checked = false;
}
